import React, { useState } from 'react';

import { PersonAddRounded } from '@mui/icons-material';

import Button from '../../../components/Button';
import ShareModal from '../../../components/ShareModal';
import {
  useGetVideoUsersQuery,
  useShareVideoMutation,
  useUnshareVideoMutation,
} from '../../../services/videos';
import useUsersQuery from '../../../utils/react/hooks/useUsersQuery';

interface ShareProps {
  targetTitle: string,
  subject: string,
  category?: string,
  topic?: string
}

const ShareButton = ({ targetTitle, subject, category, topic }: ShareProps) => {
  const [search, setSearch] = useState<string>('');
  const [shareModalOpen, setShareModalOpen] = useState<boolean>(false);

  const { data: searchRes, isFetching: isSearchResFetching } = useUsersQuery(
    { search }, { skip: search === '' || !shareModalOpen },
  );

  const { data: videoUsersData } = useGetVideoUsersQuery({
    subject, category, topic,
  }, { skip: !subject || !shareModalOpen });
  const [shareVideo, {
    error: shareError, isLoading: isShareLoading,
  }] = useShareVideoMutation();
  const [unshareVideo, {
    error: unshareError, isLoading: isUnshareLoading,
  }] = useUnshareVideoMutation();

  return (
    <>
      <Button
        size="medium"
        onClick={() => setShareModalOpen(true)}
        startIcon={(<PersonAddRounded />)}
      >Share
      </Button>
      <ShareModal
        subject={targetTitle}
        open={shareModalOpen}
        handleClose={() => setShareModalOpen(false)}
        searchUsers={(searchRes || []).filter((x) => !(videoUsersData?.data || [])
          .map((u) => u.value).includes(x?.id))}
        isSearchFetching={isSearchResFetching}
        users={videoUsersData?.data || []}
        search={(str) => setSearch(str)}
        share={(userId) => shareVideo({
          userId, subject, category, topic,
        })}
        unshare={(userId) => unshareVideo({
          userId, subject, category, topic,
        })}
        isUnshareLoading={isUnshareLoading}
        isShareLoading={isShareLoading}
        error={shareError || unshareError}
      />
    </>
  );
};

export default ShareButton;
